/**
 * Universal hook that works with direct GenAI Live API using ephemeral tokens
 * Simplified to only use the direct LiveAPI approach with proper authentication
 */

import { useContext } from "react";
import { LiveAPIContext } from "../contexts/LiveAPIContext";

export interface UniversalLiveAPIResult {
  client: any; // GenAILiveClient
  connected: boolean;
  isUsingProxy: boolean;
  connect?: () => Promise<void>;
  disconnect?: () => void;
}

export function useLiveAPIUniversal(): UniversalLiveAPIResult {
  // Use useContext directly to check availability without throwing
  const directContext = useContext(LiveAPIContext);

  if (directContext) {
    // Use direct connection with ephemeral tokens
    return {
      client: directContext.client,
      connected: directContext.connected,
      isUsingProxy: false, // We're using direct connection with ephemeral tokens
      connect: directContext.connect,
      disconnect: directContext.disconnect,
    };
  } else {
    throw new Error("No Live API client available");
  }
}